import { MeUser } from '@sp/data/bif';
import { useGate } from 'effector-react';
import { createContext, ReactElement, useContext } from 'react';
import { useAuth } from './auth';
import { USER_MODEL } from './user-model';

const UserContext = createContext<MeUser>({} as MeUser);

export function useUser() {
  return useContext(UserContext);
}

export function UserProvider({ children }: { children: ReactElement | ReactElement[] }): ReactElement | null {
  const { user, isLoading } = useAuth();
  useGate(USER_MODEL.UserGate, user);

  if (isLoading) {
    return null;
  }

  if (user == null) {
    console.error("Can't use UserContext without authenticated user.");
    return null;
  }

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
}
